import React from 'react';

const Flex = ({ 
    children, 
    direction = 'row', 
    justify = 'flex-start', 
    align = 'stretch', 
    wrap = 'nowrap', 
    gap = '0',
    isMobile = false, 
    isTablet = false, 
    isDesktop = false, 
    style, 
    className,
    ...props 
}) => {
    return (
        <div 
            className={className} 
            style={{ 
                display: 'flex',
                flexDirection: direction,
                justifyContent: justify,
                alignItems: align,
                flexWrap: wrap,
                gap: gap,
                ...style 
            }}
            {...props}
        >
            {children}
        </div>
    );
};

export default Flex;

